/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/categorize.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Groups text messages into categories of similarly formatted text values.
 *
 * @example
 * FROM sample_data
 * | STATS count=COUNT() BY category=CATEGORIZE(message)
 *
 * @example
 * FROM sample_data
 * | STATS count = COUNT(*) BY category = CATEGORIZE(message), time_bucket = BUCKET(@timestamp, 1 HOUR)
 * | SORT time_bucket DESC, count DESC, category
 *
 * @example
 * FROM sample_data
 * | STATS sample_message = SAMPLE(message, 1) BY category = CATEGORIZE(message)
 * | SORT category
 */
const definition: FunctionDefinition = {
  type: 'grouping',
  name: 'categorize',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
      license: 'PLATINUM',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
      license: 'PLATINUM',
    },
  ],
  preview: false,
  snapshotOnly: false,
  license: 'PLATINUM',
  observabilityTier: 'COMPLETE',
};

export default definition;
